<script setup lang="ts">
import type { CurrentMonthAvailableDayTile } from '../models';

import CalendarTileLayout from './CalendarTileLayout.vue';

interface CurrentMonthAvailableDayTileViewProps {
  calendarTile: CurrentMonthAvailableDayTile;
  showPrices: boolean;
  allowSelection: boolean;
}

const props = defineProps<CurrentMonthAvailableDayTileViewProps>();

interface CurrentMonthAvailableDayTileViewEmits {
  (eventName: 'select-date', date: Date): void;
}

const emit = defineEmits<CurrentMonthAvailableDayTileViewEmits>();
</script>

<template>
  <CalendarTileLayout
    :price-type="props.calendarTile.price.type"
    :selection-type="props.calendarTile.selection"
    :allow-selection="props.allowSelection"
    @click="emit('select-date', props.calendarTile.date)"
  >
    <template #day>
      {{ props.calendarTile.text }}
    </template>
    <template v-if="props.showPrices" #price>
      {{ props.calendarTile.price.value }}
    </template>
  </CalendarTileLayout>
</template>
